
<article class="contenedor">
  <h3><span class="titulo">Datos Actuales </span>| Valores actualizados al: {{strClimaLocalidad[posicionLocalidad]?.forecast.date_time}}</h3>
  <div class="contCaractClima">  
    
    <div>
      <ul>
        <li><span class="boldLista">Temperatura :</span> {{strClimaLocalidad[posicionLocalidad]?.weather.tempDesc}}</li>
        <li><span class="boldLista">Viento :</span> {{strClimaLocalidad[posicionLocalidad].weather.wing_deg }} a {{strClimaLocalidad[posicionLocalidad].weather.wind_speed }} km/h</li>
        <li><span class="boldLista">Humedad :</span> {{strClimaLocalidad[posicionLocalidad]?.weather.humidity}} %</li>
        <li><span class="boldLista">presión :</span> {{strClimaLocalidad[posicionLocalidad]?.weather.pressure}} hPa</li>
      </ul>
    </div>
    <div>
      <ul>
        <li><span class="boldLista">Temperatura Minima :</span> {{strClimaLocalidad[posicionLocalidad]?.forecast.forecast[0].temp_max}} °</li>
        <li><span class="boldLista">Temperatura Minima :</span> {{strClimaLocalidad[posicionLocalidad]?.forecast.forecast[0].temp_min }} °</li>
        <li><span class="boldLista">Sensación Termica :</span> {{strClimaLocalidad[posicionLocalidad]?.weather.st}} °</li>
      </ul>
    </div>
  </div>
  <div class="contCaractClima">
    <mat-card class="padding">
      <mat-card-title>Pronóstico extendido</mat-card-title>
      <mat-card-content>
        <ul>
          <li><span class="boldLista">Pronóstico Matutino :</span> {{strClimaLocalidad[posicionLocalidad]?.forecast.forecast[0].morning.description}}</li>
          <li><span class="boldLista">Pronóstico Diurno :</span> {{strClimaLocalidad[posicionLocalidad]?.forecast.forecast[0].afternoon.description }}</li>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>
  <button mat-button color="warn" (click)="enviarEvento()" matTooltip="Cerrar descripción" [matTooltipShowDelay]="0" [matTooltipHideDelay]="1000"> Cerrar </button>
</article>
